import React, { useEffect, useRef } from "react";
import backwardIcon from "../../assets/backwardIcon.png";
import forwardIcon from "../../assets/forwardIcon.png";
import pauseIcon from "../../assets/pause.png";
import playIcon from "../../assets/play.png";
import liveIcon from "../../assets/LiveIcon.png";
import settingIcon from "../../assets/settingIcon.png";
import languageIcon from "../../assets/languageIcon.png";
import backIcon from "../../assets/back-button.png";
import VideoSettingPage from "./VideoSettingPage";
import VideoLanguagePage from "./VideoLanguagePage";
import LoaderScreen from "../LoaderScreen";
import Wrapper from "../shared/Wrapper";
import { Translate } from "../LanguageChanger";

let resolution = window.RESOLUTION;
const playerLoaderScreen = (show) => (
  <div
    style={{
      position: "absolute",
      display: show ? "flex" : "none",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      zIndex: "2000",
      opacity: show ? 1 : 0,
      transition: "opacity 0.5s ease-in-out",
    }}
  >
    <div
      className="loader"
      style={{
        position: "relative",
        width: resolution === "FHD" ? "80px" : "60px",
        height: resolution === "FHD" ? "80px" : "60px",
      }}
    ></div>
  </div>
);

const VideoPlayerUI = ({ states, methods }) => {
  const playPauseButtonRef = useRef(false);
  const backwardButtonRef = useRef(false);
  const forwardButtonRef = useRef(false);
  const videoSettingRef = useRef(false);
  const LanguageRef = useRef(false);
  const nextEpisodeRef = useRef(false);
  const backButtonRef = useRef(false);

  const {
    handlePlayPause,
    handleRewind,
    handleForward,
    handleSeek,
    handleSettingsClick,
    handleLanguageClick,
    handleEpisodeChange,
    handleSpeedControl,
    handleQualityControl,
    handleBitrateChange,
    handleKeyDown,
    handleLanguageChange,
    handleMetadataLoaded,
    handleEnded,
    handleError,
    formatTime,
    formatMinutesSeconds,
    handleBack,
    handleSubtitleChange,
    handleSkipAd,
  } = methods;

  const {
    isPlaying,
    showBgImage,
    currentTime,
    focusedButton,
    showSettings,
    showLanguage,
    isAudio,
    adVideoRef,
    duration,
    duration_ad,
    currentTime_ad,
    loading,
    isAdPlaying,
    controlBarHeight,
    controlsColor,
    controlsVisible,
    progressBarColor,
    availableBitrates,
    adConfig,
    backgroundImage,
    isLiveContent,
    mpdXMLInfo,
    itemData,
    player,
    videoRef,
    showPlayerErrorUI,
    seekInProgress,
    currentTimeSeek,
    showPlayPauseButtonUi,
    isAdPlayingActive,
    Isnext,
    CurrentItemData,
    SkipAD,
    SkipAdTime,
    selectSpeed,
    selectedQuality,
    subtitle,
    language,
    itemDetails,
    isLive
  } = states;

  // let controlsVisible = true;
  const videoElement1 = videoRef.current;
  let currentTime1 = videoElement1?.currentTime;

  const styles = {
    container: {
      position: "relative",
      width: "100%",
      height: "100%",
      backgroundColor: "#000",
      backgroundSize: "cover",
      backgroundPosition: "center",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      fontFamily: "Anek Latin, sans-serif",
    },
    video: {
      width: "100%",
      height: "100%",
      display: isAdPlaying ? "none" : "block",
      opacity: controlsVisible ? 1 : 1,
    },
    adVideo: {
      width: "100%",
      height: "100%",
      display: isAdPlaying ? "block" : "none",
    },
    controls: {
      position: "absolute",
      bottom: "12rem",
      width: "90%",
      height: controlBarHeight,
      display: controlsVisible ? "flex" : "none",
      gap: "2rem",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: controlsColor,
      transition: "opacity 0.5s",
      opacity: controlsVisible ? 1 : 0,
      zindex: 1000,
    },
    controls_ad: {
      position: "absolute",
      bottom: "12rem",
      width: "90%",
      height: controlBarHeight,
      display: controlsVisible ? "flex" : "none",
      gap: "2rem",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: controlsColor,
      transition: "opacity 0.5s",
      opacity: controlsVisible ? 1 : 0,
      zindex: 1000,
    },
    progressBar: {
      flexGrow: 1,
      height: focusedButton === "seekBar" ? "8px" : "8px",
      backgroundColor: !isLiveContent
        ? "#333"
        : isAdPlayingActive
        ? "#333"
        : "#EC008C",

      position: "relative",
      cursor: "pointer",
    },
    progress: {
      height: "100%",
      backgroundColor: progressBarColor,
      outline: focusedButton === "seekBar" ? " #EC008C" : "none",
      position: "relative",
      display: "flex",
      alignItems: "center",
      // --- SLIDING EFFECT ADDED HERE ---
      // This makes the width change animate smoothly over 0.2 seconds
      transition: seekInProgress ? "width 0.05s linear" : "width 0.2s linear", 
    },
    progressDot: {
      position: "absolute",
      right: "-10px", 
      height: focusedButton === "seekBar" ? "32px" : "20px",
      width: focusedButton === "seekBar" ? "32px" : "20px",
      backgroundColor: "#EC008C",
      borderRadius: "50%",
      boxShadow: "0 0 5px rgba(0,0,0,0.5)",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 2,
      // Optional: adds smoothness if the dot size changes
      transition: "width 0.1s, height 0.1s", 
    },
    adMarker: {
      position: "absolute",
      width: "3px",
      height: "100%",
      backgroundColor: !isLiveContent ? "red" : "transparent",
      marginTop: "-10px",
    },
    timeDisplay_ad: {
      padding: "10px",
      fontSize: "24px",
      width: "204px",
      textAlign: "left",
      color: !isLiveContent ? "#FFF" : "#FFF",
    },
    timeDisplay: {
      padding: "10px",
      fontSize: "24px",
      width: "204px",
      textAlign: "left",
      color: !isLiveContent ? "#FFF" : "transparent",
    },
    settingsLanguageContainer: {
      position: "absolute",
      display: controlsVisible ? "flex" : "none",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      gap: "2rem",
      bottom: "5rem",
    },
    settingsLanguageItem: {
      margin: "0 1.2rem",
    },
    controlButtons: {
      position: "absolute",
      display: controlsVisible ? "flex" : "none",
      gap: "2rem",
    },
    button: {
      padding: "0.5rem",
      fontSize: "1rem",
      color: "#FFF",
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      width: "100%",
      borderRadius: "1rem",
    },
    controlButton: {
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 0.8rem",
      padding: "0.5rem",
      color: "#FFF",
      outline: "none",
      border: "none",
      borderRadius: "1rem",
      backgroundColor: "transparent",
    },
    settingsWrapper: {
      position: "absolute",
      top: "10px", 
      right: "10px", 
      zIndex: 100, 
    },
    focusedButton: {
      outline: "3px solid #EC008C",
    },
  };

  const styleStrings = {
    focused:
      focusedButton === "skipAd" ? "4px solid #fff" : "4px solid #EC008C",
  };

  return (
    <div style={styles.container}>
      {playerLoaderScreen(loading)}

      {/* // Error popup */}
      {showPlayerErrorUI && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            fontSize: "1.5rem",
            maxWidth: "45rem",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgb(29, 29, 29)",
            padding: "3rem",
            borderRadius: "1rem",
            color: "white",
            zIndex: 99999,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1 style={{ marginTop: "-0.5rem" }}>Oops! Something went wrong</h1>
          <p style={{ marginTop: "-1rem" }}>
            We are unable to load the video. Please try again later...
          </p>
          <Wrapper
            as="button"
            style={{
              padding: "1rem",
              backgroundColor: "#EC008C",
              color: "white",
              border: "none",
              borderRadius: "1rem",
              cursor: "pointer",
              fontSize: "1.3rem",
              fontWeight: "bold",
            }}
            onClick={handleBack}
          >
            Go back
          </Wrapper>
        </div>
      )}

      {controlsVisible && itemData && itemData.title && (
        <div
          style={{
            position: "absolute",
            top: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            gap: "2rem",
            zIndex: 10,
          }}
        >
          {/* <Wrapper
            as="button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              marginLeft: "3rem",
              borderRadius: "1rem",
              aspectRatio: "1/1",
              cursor: "pointer",
              outline:
                focusedButton === "backButton" ? styleStrings.focused : "none",
            }}
            ref={backButtonRef}
            onClick={handleBack}
            onKeyDown={handleKeyDown}
          >
            <img src={backIcon} width={80} height={80} />
          </Wrapper> */}

          <h1 style={{ color: "white", fontSize: "4rem" }}>
            {CurrentItemData ? CurrentItemData?.title : itemData.title}
          </h1>
        </div>
      )}

      {/* // Background image */}
      {showBgImage && backgroundImage && (
        <img
          src={backgroundImage}
          alt="Background"
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: 0,
          }}
        />
      )}

      {/* // Main video */}
      <video
        id="video-player-shaka"
        ref={videoRef}
        style={styles.video}
        onEnded={handleEnded}
        onError={handleError}
        controls={false}
        autoPlay
        preload="auto"
        height="100vh"
        width="100vw"
        onLoadedMetadata={handleMetadataLoaded}
      />
      {controlsVisible && !isAdPlayingActive && (
        <div id="trickplay-container">
          <div
            id="trickplay-image"
            style={{
              width: "480px",
              height: "272px",
              backgroundSize: "2400px auto",
              backgroundRepeat: "no-repeat",
              display: "none",
            }}
          />
        </div>
      )}

      {/* // Ad video */}
      <video
        id="ads-player-shaka"
        ref={adVideoRef}
        style={styles.adVideo}
        onEnded={handleEnded}
        onError={handleError}
        controls={false}
        autoPlay
        preload="auto"
        height="100vh"
        width="100vw"
        onLoadedMetadata={handleMetadataLoaded}
      />

      {/* // Play, Pause, Rewind and Forward buttons */}
      <div onKeyDown={handleKeyDown} style={styles.controlButtons}>
        {/* // Play/Pause button */}
        <Wrapper
          as="button"
          style={{
            ...styles.controlButton,
            outline: focusedButton === "playPause" ? "none" : "none",
            opacity: showPlayPauseButtonUi ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
          }}
          ref={playPauseButtonRef}
          onClick={handlePlayPause}
        >
          {isPlaying ? (
            <img
              src={pauseIcon}
              width={100}
              height={100}
              style={{
                transform: focusedButton === "playPause" ? "scale(1.5)" : "scale(1)",
                transition: "transform 150ms ease-in-out",
                willChange: "transform",
              }}
            />
          ) : (
            <img
              src={playIcon}
              width={100}
              height={100}
              style={{
                transform: focusedButton === "playPause" ? "scale(1.15)" : "scale(1)",
                transition: "transform 150ms ease-in-out",
                willChange: "transform",
              }}
            />
          )}
        </Wrapper>
      </div>

      {isAdPlayingActive && !isLiveContent ? (
        <>
          <div style={styles.controls_ad}>
            <Wrapper style={{ ...styles.progressBar }}>
              <div
                className="seek-bar"
                style={{
                  ...styles.progress,
                  width:
                    duration_ad && !isNaN(duration_ad)
                      ? `${Math.min((currentTime_ad / duration_ad) * 100, 100)}%`
                      : "0%",
                }}
              >
                <div style={styles.progressDot}></div>
              </div>
            </Wrapper>

            <div style={styles.timeDisplay_ad}>
              <span style={{ display: "inline-block", minWidth: "89px" }}>
                {formatMinutesSeconds(currentTime_ad)}
              </span>{" "}
              /{" "}
              <span style={{ display: "inline-block", minWidth: "89px" }}>
                {formatMinutesSeconds(duration_ad)}
              </span>
            </div>
          </div>

          {
            <div
              style={{
                ...styles.controls_ad,
                position: "absolute",
                bottom: "15rem",
                left: "7rem",
                width: "auto",
              }}
            >
              <span
                style={{
                  color: "white",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                  backgroundColor: "rgb(0 0 0 / 40%)",
                  padding: "10px 20px",
                  borderRadius: "10px",
                }}
                // onClick={handleSkipAd}
              >
                Ad
              </span>
            </div>
          }

          {SkipAD && (
            <div
              style={{
                ...styles.controls_ad,
                position: "absolute",
                bottom: "16rem",
                right: "7rem",
                width: "auto",
              }}
            >
              <span
                style={{
                  color: "white",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                  backgroundColor: "rgb(236 0 140)",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  outline:
                    focusedButton === "skipAd" ? styleStrings.focused : "none",
                }}
                onClick={handleSkipAd}
              >
                Skip Ad
              </span>
            </div>
          )}
        </>
      ) : (
        <>
          {/* Progress bar & Time display */}
          <div style={styles.controls}>
            {!isAdPlayingActive && (
              <div style={{ ...styles.progressBar }} onClick={handleSeek}>
                <div
                  className="seek-bar"
                  style={{
                    ...styles.progress,
                    // The logic here switches between seek time and play time
                    // combined with the CSS transition, this creates the slide effect
                    width: isLiveContent
                      ? "100%"
                      : duration && !isNaN(duration)
                      ? `${
                            ((seekInProgress ? currentTimeSeek : currentTime) /
                              duration) *
                            100
                          }%`
                        : "0%",
                  }}
                >
                  <div style={{
                    ...styles.progressDot,
                    ...(isLiveContent &&{right:"-10px",left:"auto"})
                    }}></div>
                </div>
              </div>
            )}

            {!isLiveContent && !isAdPlayingActive ? (
              <div style={styles.timeDisplay}>
                <span style={{ display: "inline-block", minWidth: "89px" }}>
                  {/* Updated to show seek time when seeking so numbers match the slide */}
                  {formatTime(seekInProgress ? currentTimeSeek : currentTime)}
                </span>{" "}
                /{" "}
                <span style={{ display: "inline-block", minWidth: "89px" }}>
                  {formatTime(duration)}
                </span>
              </div>
            ) : isAdPlayingActive ? (
              <>
                {
                  <div
                    style={{
                      ...styles.controls_ad,
                      position: "absolute",
                      bottom: "3rem",
                      left: "0rem",
                      width: "auto",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontSize: "1.5rem",
                        cursor: "pointer",
                        backgroundColor: "rgb(0 0 0 / 40%)",
                        padding: "10px 20px",
                        borderRadius: "10px",
                      }}
                      onClick={handleSkipAd}
                    >
                      Ad
                    </span>
                  </div>
                }
                <Wrapper style={{ ...styles.progressBar }} onClick={handleSeek}>
                  <div
                    className="seek-bar"
                    style={{
                      ...styles.progress,
                      width:
                        duration_ad && !isNaN(duration_ad)
                          ? `${(currentTime_ad / duration_ad) * 100}%`
                          : "0%",
                    }}
                  >
                    <div style={styles.progressDot}></div>
                  </div>
                </Wrapper>

                <div style={styles.timeDisplay_ad}>
                  <span style={{ display: "inline-block", minWidth: "89px" }}>
                    {formatTime(currentTime_ad)}
                  </span>{" "}
                  /{" "}
                  <span style={{ display: "inline-block", minWidth: "89px" }}>
                    {formatTime(duration_ad)}
                  </span>
                </div>
              </>
            ) : (
              <img
                src={liveIcon}
                alt="Live Icon"
                style={{
                  position: "absolute",
                  width: "104px",
                  height: "43px",
                  bottom: "2rem",
                  marginLeft: "84.5vw",
                }}
              />
            )}
          </div>
        </>
      )}

      {!isAdPlayingActive && !isAdPlaying && !loading ? (
        <>
          {/* Settings and Language buttons */}
          <div style={styles.settingsLanguageContainer}>
            {/* Settings button */}
            <div style={styles.settingsLanguageItem} onKeyDown={handleKeyDown}>
              <Wrapper
                as="button"
                style={{
                  ...styles.button,
                  width: "10rem",
                  outline:
                    focusedButton === "videoSetting"
                      ? styleStrings.focused
                      : "none",
                  fontFamily: "Anek Latin, sans-serif",
                }}
                ref={videoSettingRef}
                onClick={handleSettingsClick}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1rem",
                    fontSize: "1.4rem",
                  }}
                >
                  <img src={settingIcon} alt="Settings Icon" />
                  <p><Translate langKey={"settings"}/></p>
                </div>
              </Wrapper>
            </div>

            {/* Language button */}
            <div style={styles.settingsLanguageItem} onKeyDown={handleKeyDown}>
              <Wrapper
                as="button"
                style={{
                  ...styles.button,
                  width: "13rem",
                  outline:
                    focusedButton === "videoLanguage"
                      ? "3px solid #EC008C"
                      : "none",
                }}
                ref={LanguageRef}
                onClick={handleLanguageClick}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1rem",
                    fontSize: "1.4rem",
                  }}
                >
                  <img src={languageIcon} alt="Language Icon" />
                  <p><Translate langKey={"language"}/></p>
                </div>
              </Wrapper>
            </div>
            {!Isnext && !isLiveContent && !isLive && (
              <div
                style={styles.settingsLanguageItem}
                onKeyDown={handleKeyDown}
              >
                <Wrapper
                  as="button"
                  style={{
                    ...styles.button,
                    width: "15rem",
                    outline:
                      focusedButton === "NextEpisode"
                        ? "3px solid #EC008C"
                        : "none",
                  }}
                  ref={nextEpisodeRef}
                  onClick={handleEpisodeChange}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "1rem",
                      fontSize: "1.4rem",
                    }}
                  >
                    <img src={playIcon} alt="Language Icon" width={60} />
                     <p>Next Episode</p>
                  </div>
                </Wrapper>
              </div>
            )}
          </div>
        </>
      ) : null}

      {/* // Settings overlay */}
      {showSettings && (
        <div style={styles.settingsWrapper}>
          <VideoSettingPage
            availableBitrates={availableBitrates}
            onBitrateChange={handleBitrateChange}
            mpdXMLInfo={mpdXMLInfo}
            handleSpeedControl={handleSpeedControl}
            handleQualityControl={handleQualityControl}
            player={player}
            isLiveContent={isLiveContent}
            currentSpeed={selectSpeed}
            currentQuality={selectedQuality}
            itemData={states.itemDetails}
            CurrentItemData={states.CurrentItemData}
          />
        </div>
      )}

      {/* // Language overlay */}
      {showLanguage && (
        <div style={styles.settingsWrapper}>
          <VideoLanguagePage
            mpdXMLInfo={mpdXMLInfo}
            videoElement={videoRef}
            player={player}
            handleLanguageChange={handleLanguageChange}
            handleSubtitleChange={handleSubtitleChange}
            subtitle={subtitle}
            language={language}
            itemData={states.itemDetails}
            CurrentItemData={states.CurrentItemData}
          />
        </div>
      )}

      {/* // Audio Only Content */}
      {isAudio && (
        <img
          src={backgroundImage}
          alt="Background"
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: 1000,
            margin: "0px",
          }}
        />
      )}
    </div>
  );
};

export default VideoPlayerUI;